const btn = document.getElementById('toggle-mobile-nav');
const nav = document.getElementById('mobile-nav');

btn?.addEventListener('click', () => {
    // console.log(nav);
    
    nav.classList.toggle('scale-y-0');
    nav.classList.toggle('scale-y-100');
});